// 最大id已使用到12
const config = {
  title: '查号验号',
  id: '3',
  list: [
    {
      title: '为什么做亚马逊就一定要查买家账号安全？',
      id: '1',
      content: `2021年出现的大规模的封号封店，就是由于亚马逊卖家刷单被查导致，为什么会被查，核心的就是刷单的买家账号是危险的、是被亚马逊的稽查系统监控的，进入了亚马逊黑名单的。<br/>
          只要卖家一用这样的黑名单账号刷单，必然别抓。轻则删链接处罚，重的直接封品牌封店铺没收钱！<br/>
          我们是绝对反对刷单的，但是由于新品上新等必须需要一定合理的评测，及时发现产品问题，那么评测时候就必须保证账号绝对是安全的。需要卖家详细分析买家账号历史留评情况、差评风险等级、历史留评被删情况、账号注册时长、账号是否异常、是否已经是黑名单等，如果能够确保这个买家账号安全，就基本上能保证评测的安全，大大降低风险。 <br/>`,
    },
    {
      title: '怎么查买家账号安全？',
      id: '2',
      content: `一般卖家常用的方法是安排专门专员来对接买家，简单看看买家的 Profile页面情况，但是实际上没有对买家账号全面完整的分析，是不可能短时间确认账号是否安全的。<br/>
          确认买家账号安全的指标我们快现形统计了 30个以上，大家可以通过以下两种方法在查询：<br/>
          Profile ID查询：请在输入框内输入Profile ID，并点击查询；<br/>
          Profile页面：姓名+helpfulvotes+reviews+地址+最近留评时间五项整合查询。<br/>
          <p><img src="https://kxxprod.oss-cn-hangzhou.aliyuncs.com/kxxprod/image/default/20211012/uf4000.png" style="height:966px; width:1025px"></p>
          查询后会出来 30个结果，这个数据大家就可以直接参考用了。`,
    },
    {
      title: '快现形验号查号的原理？',
      id: '3',
      content: `大家应该知道什么是犯罪记录吧？<br/>
          坏人的指纹和正常人的指纹是分开来的，如果一个人犯罪，他的指纹将在坏人库里。<br/>
          当我们想查询一个人是否有问题时，我们会先去坏人指纹库检查！<br/>
          所以现在是一样的，如果我们收集所有的黑号、问题账号，那么我们在做推广之前检查它们，是不是立即能确定这个小号就是一个黑号、问题号了呢？<br/>`,
    },
    {
      title: '快现形验号查号的特点？',
      id: '4',
      content: `首创亚马逊问题账号数据库系统 ,拥有<span style="color:#ff0000">千万级问题号数据库</span> ,让降权黑号骗子无处可藏，查号就在我们的数据库里查，只需一个账号ID，1秒完成，无需再去买家页面人肉猜测账号是否安全了！`,
    },
    {
      title: '快现形查号验号的好处?',
      id: '5',
      content: `1、测评找的买家账号如果有问题，比如账号是亚马逊黑名单、账号被删除过评论、账号是骗子账号、恶意差评账号等，这类账号来到你的店铺购买，就有可能被列为虚假交易，卖家有封号、封品牌、封链接、扣钱的巨大风险。<br/>
          2、及时发现亚马逊问题账号，安全放心测评，顺利打造爆品链接。<br/>
          3、及时发现恶意给中差评买家、发现中介骗子，防范账号与资金风险。<br/>
          4、快现形能够最短时间无死角的分析买家账号30个维度的指标，这个是光靠人力没法办成的，能够极大增强运营效率。`,
    },
    {
      title: '验号查号细节哪些指标最关键？',
      id: '6',
      content: `第一维度，也是最最最关键指标：<br/>
    账号安全等级、黑名单、被查次数、 Profile是否隐藏、留评被删数、留评被删评估、最近半年被删除评论数、隐藏评论数、至少被平台认定的违规次数<br/>
    第二重要维度：给过差评数、差评风险评估；近六个月、近一年、全部的留评数、留评比例、留评排名、账号年限<br/>
    第三重要维度：近一年留评星级分布、总留评星级分布、总投票数、均投票数、均投票数排名<br/>
    第四重要维度：姓名、 TOP买家、Vine标、名人堂、活跃指数、账号排名<br/>
    重点关注第一、第二重要维度的评价指标。<br/>
    多应用软件，多分析，各位亲一定的能以火眼金睛验出所有的问题账号，保证测评的安全。`,
    },
    {
      title: '快现形产品查号都需要收费吗？',
      id: '7',
      content: `我们产品分为免费版块和付费版块。<br/>
      我们有一直免费的查黑号和骗子的入口，里面统计了将近 几十 万个各种问题和骗子信息，大家可以直接去这里举报骗子（买家骗子、中介骗子、卖家骗子等），让骗子无所遁形，打造一个干净健康的运营环境。这些举报打标信息为卖家主动共享，快现形为大家提供免费使用，不对相关使用效果或纠纷承担责任。<br/>
      同时我们有全面的亚马逊买家 Profile页面分析系统数据，这一部分是付费的。<br/>
      快现形会根据不同时期，出台不同的付费优惠/免费正常，欢迎关注！`,
    },
    {
      title: '快现形产品查号怎么收费？',
      id: '8',
      content: `由于系统工作量太大，针对收费查询，我们统一的标准是每查询一次，将扣除 1积分，如果当日该会员重复查询同一买家账号，不会重复计费。<br/>
<span style="color:#ff0000">另外，我们 24小时后给您更新的买家账号报告，也不需要重新计费。</span><br/>
      快现形会根据不同时期，出台不同的付费优惠/免费正常，欢迎关注！`,
    },
    {
      // title: '什么是 Profile ID?',
      title: '什么是买家Profile?',
      id: '9',
      content: `每个亚马逊的买家都有自己独有的 Profile 链接，大家通过下面这个页面看到的就是公开的Profile 链接。
      <p><img style="height: 671px;" src="https://kxxprod.oss-cn-hangzhou.aliyuncs.com/kxxprod/image/default/20211215/uf11501.png"></p>`
      // content: `每个亚马逊的买家都有自己独有的 Profile ID，大家通过下面这个页面看到的就是公开的Profile ID。
      //     <p><img src="https://kxxprod.oss-cn-hangzhou.aliyuncs.com/kxxprod/image/default/20211012/uf4001.png" style="height:671px; width:794px"></p>`,
    },
    {
      title: '买家如何在手机上获取自己的 profile ID链接？',
      id: '10',
      content: `当卖家向买家索要 Profile ID时，如果买家在电脑旁，直接复制对应的买家Profile页面即可；但是如果买家使用的是手机，就需要按照以下六个步骤操作了：<br/>
      1、卖家发一个profile链接给买家（任意一个profile链接）；<br/>
      2、买家在手机浏览器中输入上述该profile链接；<br/>
      3、点击 view your public profile；<br/>
      4、买家输入自己的amazon账号和密码，登录自己的public profile；<br/>
      5、登录成功，点击手机浏览器右上角三个点，找到复制链接（如果没有这一项则选择发送给好友）；<br/>
      6、发送复制链接就可以啦，这个就是买家自己的profile链接啦！<br/>
      具体流程如下视频显示：
      <p><video class="vjs-tech" id="video-1" tabindex="-1" role="application" controls="" preload="auto" src="https://kxxprod.oss-cn-hangzhou.aliyuncs.com/kxxprod/image/default/20211026/uf6501.mp4" muted="muted"></video></p>`,
    },
    {
      // title: '目前只能查询美国站吗？其他站点什么时候可以查询？',
      title: '目前除了美国站、德国站、英国站、加拿大站吗？其他站点什么时候可以查询？',
      id: '11',
      // content: `目前公司正在全力开发中，预计2022年1-2月会陆续上线德国站、英国站，其它加拿大、日本、法国、意大利、西班牙等更多站点上线时间，关注快现形公众号，我们会第一时间发布通知。`,
      content: `快现形目前已经上线美国站、德国站、英国站、加拿大站，其他站点目前公司正在全力开发中，其日本、法国、意大利、西班牙等更多站点上线时间，关注快现形公众号，我们会第一时间发布通知。`,
    },
    {
      title: '怀疑被恶意差评，怎么向亚马逊申诉？',
      id: '12',
      content: `怀疑被恶意差评之后，先通过快现形查这个买家账号；如果发现买家账号是一个危险账号、极度危险账号，给差评也多，被删评论比较多等，可以找亚马逊客服开case，说被恶意差评。<br/>
      体操作详见链接：
      <a href="https://kxxprod.oss-cn-hangzhou.aliyuncs.com/kxxprod/image/default/20220216/uf16030.mp4" rel="noopener" target="_blank">https://kxxprod.oss-cn-hangzhou.aliyuncs.com/kxxprod/image/default/20220216/uf16030.mp4</a>`,
      // <p><video class="vjs-tech" id="video-1" tabindex="-1" role="application" controls="" preload="auto" src="https://kxxprod.oss-cn-hangzhou.aliyuncs.com/kxxprod/image/default/20211026/uf6501.mp4" muted="muted"></video></p>
    },
  ],
}

export default config
